module.exports = __webpack_public_path__ + "static/img/79.760cd19.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/79.png
// module id = ZJrk
// module chunks = 1